module.exports = __webpack_public_path__ + "img/values.8b164227.svg";